const getProductCategories = (productCategoriesCompound, page) => {
  return productCategoriesCompound?.map(({ categoryTitle, description, imageLink, link, key }) => {
    const imageObject = page.getContent(imageLink);
    return {
      title: categoryTitle,
      description,
      image: {
        url: imageObject?.getOriginal()?.getUrl() || "",
        description: imageObject?.getDescription() ?? null
      },
      key,
      link: link?.url
    };
  });
};
export {
  getProductCategories
};
//# sourceMappingURL=get-product-categories.js.map
